import React from 'react';

import ForgotApp from './components/forgot-app';
import WithQuery from '../../../../common/components/with-query';

const Forgot = props => {
  return (
    <WithQuery query={props.location.search}>
      <ForgotApp />
    </WithQuery>
  );
}

export default Forgot;
